import { useOutletContext } from "react-router-dom";
import { formatDate } from "../services/helpers";

export function MemberDetailsSubscriptions(){
	const contextData = useOutletContext();
	const subscriptionHistory = contextData.subscription_history.history;
	if (subscriptionHistory.length === 0 ){
		return <h3>No subscription history found!</h3>;
	}
	return (
		<table>
			<thead>
						<tr>
							<th>Plan Name</th>
							<th>Date Subscribed </th>
							<th>Date Expired</th>
							<th>Amount Paid</th>
							<th>Payment method</th>
							<th>Transaction Id</th>
						</tr>
					</thead>
					<tbody>
						{subscriptionHistory.map((subscription) => (
							<tr key={subscription.entry_id}>
								<td>{subscription.plan_name}</td>
								<td>{formatDate(subscription.date_subscribed,false)}</td>
								<td>{formatDate(subscription.expiry_date,false)}</td>
								<td>{subscription.currency} {subscription.amount}</td>
								<td>{subscription.method_name}</td>
								<td>{subscription.transaction_id}</td>
								{/* <td className={`${checkExpiry(car.roadworthy_expiry) && "red-text"}`}>{car.roadworthy_expiry ?? "n/a"}</td> */}
								{/* <td><Link to={`/dashboard/vehicles/${car.license_plate}`}>View Vehicle</Link></td> */}
							</tr>
						))}
					</tbody>
		</table>
	);

}